import React, { useEffect, useRef } from "react";
import { GET_PROJECTS } from "../graphql/queries";
import { useQuery } from "@apollo/client";
import { Link } from "react-router-dom";
import { ROUTES } from "../routes/routes";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function Portfoliocarousel() {
    const { loading, error, data } = useQuery(GET_PROJECTS);
    const portfolioRef = useRef(null);

    useEffect(() => {
        if (portfolioRef.current) {
            gsap.fromTo(
                portfolioRef.current,
                { opacity: 0, y: 50 },
                {
                    opacity: 1,
                    y: 0,
                    duration: 1,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: portfolioRef.current,
                        start: "top 80%",
                        toggleActions: "play none none none",
                    },
                }
            );
        }
    }, [portfolioRef, data]);

    if (loading) return <p>Loading...</p>;
    if (error) {
        console.error(error);
        return <p>Error : {error.message}</p>;
    }

    const randomProject =
        data.portfolios[Math.floor(Math.random() * data.portfolios.length)];

    return (
        <Link
            to={`${ROUTES.project.path}/${randomProject.slug}`}
            key={`project-${randomProject.slug}`}
            className="portfolio-container"
            ref={portfolioRef}
        >
            <div key={randomProject.id} className="portfolio-card">
                <img
                    src={randomProject.image.url}
                    alt={randomProject.title}
                    className="portfolio-image"
                />
                <div className="portfolio-content">
                    <h2>{randomProject.title}</h2>
                    <p className="portfolio-author">{randomProject.author}</p>
                </div>
            </div>
        </Link>
    );
}
